import React from 'react';
import AnswerCard from './AnswerCard.jsx';
import './analyticsAsk.css';

// Pure module — NO context/service imports (statically testable in this no-jsdom workspace).

/** `{kind:'overview'}` — a stack of compact AnswerCards in server order (one per cohort
 *  metric, Task 8/#1659). A `{metric, error:true}` card (a defensive refusal from a
 *  server-authored intent — should not happen, but never fabricate a partial answer) renders
 *  a one-line fallback instead of a broken AnswerCard.
 *
 *  `scopeApplied` (Task 11 fix wave, #1661/#1663 iteration 1) — the compound's top-level
 *  {type:'org'|'group', label} (overview.js), rendered as one muted disclosure line ABOVE the
 *  card stack (Decision 8 — disclose scope once, plainly). Undefined/null (every pre-Task-11
 *  payload, and a stub that omits it) renders nothing extra — byte-identical to before. */
export default function OverviewCards({ cards = [], scopeApplied = null }) {
  return (
    <div className="aa-overview">
      {scopeApplied?.label && (
        <p className="aa-overview__scope">Showing {scopeApplied.label}.</p>
      )}
      {cards.map((c, i) => (
        c.error
          ? <div key={c.metric ?? i} className="aa-overview__error">Couldn’t load this one.</div>
          : <div key={c.metric ?? i} className="aa-overview__item"><AnswerCard presentation={c.presentation} /></div>
      ))}
    </div>
  );
}
